var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconBiege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_48522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6994 11.4072L12.8702 18.3246L6.04688 11.4072",
    stroke: "#FFFAF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8789 17.7512V1.2207",
    stroke: "#FFFAF0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3064 18.3184V23.7883H1.71094V18.3184",
    stroke: "#FFFAF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_48522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7687,
    height: 24.7687,
    fill: "white",
    transform: "translate(0.617188 0.116211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBiege);
export default __webpack_public_path__ + "static/media/download_icon_biege.8dfbf959e315e08801b877dbd050ff95.svg";
export { ForwardRef as ReactComponent };